import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Header, Grid, Button, Table, Loader} from 'semantic-ui-react';
import {parseWarrantyInvoicingFileData, getHeaderValues} from '../../utils';
import {Actions} from '../../../common/actions';
import ExcelReader from '../../../excelReader/components/index';
import WarrantyInvoiceTable from './warrantyInvoiceTable';
import './styles.scss';

const INITIAL_STATE = {
  'invoice': '',
};

class WarrantyReport extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  componentWillUnmount() {
    this.cleanWarrantyInvoicing();
  }

  readExcelFile = (data) => {
    const invoice = getHeaderValues(data[0]);
    this.setState({'invoice': invoice});
    const warrantyInvoiceData = data.slice(2);
    const loadedWarrantyInvoice =
      parseWarrantyInvoicingFileData(warrantyInvoiceData);
    this.props.loadingExcel(false);
    this.props.processWarrantyInvocingList(loadedWarrantyInvoice);
  };

  updateWarrantyInvoice = () => {
    const {invoiceList} = this.props;
    const {invoice} = this.state;
    const data = {
      'warrantyInvoicing': invoiceList,
      'invoice': invoice,
    };
    this.props.updateWarrantiesInvoicing(data);
  }

  cleanWarrantyInvoicing = () => {
    this.setState(INITIAL_STATE);
    this.props.clearWarrantyInvoicingList();
  };

  renderLoader() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Cargando información' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {loadingExcelFile, loading, invoiceList} = this.props;
    const {invoice} = this.state;
    const isInvalidData = invoiceList.some((invoice) => invoice.invalid || invoice.updated);

    return (
      <div className='warranty-invoice'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta Facturación de Garantías</h2>
              <div className='title-bar-actions'>
                <Button secondary disabled={loading} onClick={this.cleanWarrantyInvoicing}>
                  LIMPIAR
                </Button>
                <ExcelReader
                  saving={loadingExcelFile || loading}
                  text='CARGAR'
                  onGetFile={this.readExcelFile}
                />
                <Button
                  primary
                  disabled={!invoiceList.length || isInvalidData || loading}
                  onClick={this.updateWarrantyInvoice}
                >
                  ACTUALIZAR
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className='warranty-invoice-subheader'>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                <Header size='medium'>Número de Factura</Header>
                <span>{invoice}</span>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Card raised fluid>
          {loadingExcelFile || loading ? (
            this.renderLoader()
          ) : (
            <WarrantyInvoiceTable dataTable={invoiceList} />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loadingExcelFile': state.excelReader.loading,
    'invoiceList': state.warrantyInvoicing.list,
    'loading': state.warrantyInvoicing.loading,
  };
};

const {
  withRouter,
  navigateTo,
  loadingExcel,
  updateWarrantiesInvoicing,
  clearWarrantyInvoicingList,
  processWarrantyInvocingList,
} = Actions;

const mapDispatchToProps = {
  navigateTo,
  loadingExcel,
  updateWarrantiesInvoicing,
  clearWarrantyInvoicingList,
  processWarrantyInvocingList,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WarrantyReport)
);
